import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = ({ size = 40, className = '', theme }) => {
  return (
    <div className="flex justify-center py-20">
      <Loader2 
        className={`animate-spin ${theme?.textSubtle || ''} ${className}`} 
        size={size} 
      />
    </div>
  );
};

export default LoadingSpinner;